<template>
  <div class="layout-wrapper">
    <main class="main-content">
      <AccountDeactivated
        v-if="showDeactivated"
        :slug="$route.params.slug"
        :dealer-name="dealerName"
      />
      <router-view v-else></router-view>
    </main>
    <AppFooter />
  </div>
</template>

<script>
import axios from 'axios';
import AppFooter from '../components/Footer.vue';
import AccountDeactivated from '../components/AccountDeactivated.vue';

export default {
  name: 'layout-default',
  components: {
    AppFooter,
    AccountDeactivated
  },
  data() {
    return {
      activeCheck: { status: 'idle', slug: null }
    };
  },
  computed: {
    accountSlug() {
      return this.$route && this.$route.params ? this.$route.params.slug : null;
    },
    isAccountRoute() {
      return !!(this.$route && this.$route.path && this.$route.path.startsWith('/account/'));
    },
    showDeactivated() {
      return this.isAccountRoute && this.activeCheck.slug === this.accountSlug && this.activeCheck.status === 'inactive';
    },
    dealerName() {
      if (!this.accountSlug) return '';
      return this.accountSlug
        .split('-')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
    }
  },
  watch: {
    accountSlug: {
      immediate: true,
      handler(slug) {
        if (slug && this.isAccountRoute) {
          this.checkActive(slug);
        } else {
          this.activeCheck = { status: 'idle', slug: null };
        }
      }
    }
  },
  methods: {
    async checkActive(slug) {
      this.activeCheck = { status: 'checking', slug };
      try {
        const { data } = await axios.get(`/.netlify/functions/check-account-active?slug=${encodeURIComponent(slug)}`, { timeout: 20000 });
        if (this.accountSlug !== slug) return;
        this.activeCheck = { status: data && data.active === false ? 'inactive' : 'active', slug };
      } catch (e) {
        if (this.accountSlug !== slug) return;
        this.activeCheck = { status: 'active', slug };
      }
    }
  }
};
</script>

<style scoped>
.layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-bottom: 20px;
}

@media (max-width: 768px) {
  .main-content {
    padding-bottom: 20px;
  }
}
</style>
